import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-token-expired',
  templateUrl: './token-expired.component.html',
  styleUrls: ['./token-expired.component.scss'],
  standalone: false,
})
export class TokenExpiredComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
